import { useQuery } from '@tanstack/react-query'

import { orpc } from '@/orpc/client'

export const useYouTubeStat = () => ({ data: undefined })
export const useGitHubStat = () => ({ data: undefined })
export const useBlogLikeStat = () => ({ data: undefined })
export const useBlogViewStat = () => ({ data: undefined })
export const useWakatimeStat = () => ({ data: undefined })
export const useSpotifyStat = () => {
    return useQuery({
        queryKey: ['spotify-now-playing'],
        queryFn: async () => {
            const res = await fetch('/api/spotify', { cache: 'no-store' })
            if (!res.ok) throw new Error('Failed to fetch Spotify status')
            return (await res.json()) as {
                isPlaying: boolean
                songUrl: string | null
                name: string | null
                artist: string | null
            }
        },
        refetchInterval: 15000
    })
}
